import React from 'react';
import { Button } from 'antd';
import ReactTooltip from 'react-tooltip';

// import '../style/PracticeDetails.scss';

import IconItem from './IconItem';
import TextInfoItem from './TextInfoItem';

import AddrLink from './AddrLink';
import SocialIcons from './SocialIcons';
import PeopleList from './PeopleList';
import HoursList from './HoursList';
import Spacer from './Spacer';
import PricingTable from './PricingTable';
import InfoItem from './InfoItem';
import TypeTag from './TypeTag';
import { Row } from './Flex';

import * as util from '../util';
import { panelIcons, panelTexts } from '../data.js';

const PracticeDetails = ({ data: p }) => {
  if (!p) {
    return (
      <div className={'PracticeDetails'}>
        <div>
          <small>
            <span>No practice selected.</span>
            <br />
            <span style={{ color: '#00000080' }}>
              Click a practice's icon to see its information here.
            </span>
          </small>
        </div>
      </div>
    );
  }

  let panelStatus = util.computePanelStatus(p.people);

  return (
    <div className={'PracticeDetails'}>
      <div>
        <ReactTooltip multiline={true} />
        <TypeTag p={p} />
        <Row justify="flex-start" align="flex-start">
          <h3>{p.name + ' '}</h3>
        </Row>

        <Button
          className="cstm"
          type="primary"
          size={'default'}
          href={`/practice/${p.id}`}
          target="_blank"
        >
          View Full Profile
        </Button>
      </div>
      <div>
        <IconItem icon={panelIcons[panelStatus]}>
          <p>{panelTexts[panelStatus]}</p>
          <Spacer size="xsmall" />
        </IconItem>

        {p.address && (
          <IconItem icon="shop">
            <p>{util.addrString(p.address)}</p>
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.address && (
          <IconItem icon="environment">
            <AddrLink addr={p.address} text="Get directions" />
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.website && (
          <IconItem icon="link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={util.httpify(p.website)}
            >
              {util.httpify(p.website)}
            </a>
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.phone && (
          <IconItem icon="phone">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${p.phone}`}
            >
              {p.phone}
            </a>
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.cell && (
          <IconItem icon="mobile">
            <a target="_blank" rel="noopener noreferrer" href={`tel:${p.cell}`}>
              {p.cell}
            </a>
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.fax && (
          <IconItem icon="printer">
            {p.fax}
            <Spacer size="xsmall" />
          </IconItem>
        )}
        {p.people && p.people.length > 0 && (
          <IconItem icon={p.people.length > 1 ? 'team' : 'user'}>
            <PeopleList p={p} />
            <Spacer size="xsmall" />
          </IconItem>
        )}
        <SocialIcons title="Online profiles" p={p} />
        <TextInfoItem
          title="Specialty"
          content={
            util.computeSpecialties(p.people) || 'Family Medicine'
            // util.objify(specialties, 'value', 'label')[p.specialty] || 'None'
          }
        />
        <TextInfoItem title="Open since" content={p.openDate} />
        <TextInfoItem title="Ages accepted" content={p.acceptedAges} />
        <HoursList title="Hours" p={p} />
        <InfoItem title="Pricing">
          <PricingTable prices={p.prices} />
        </InfoItem>

        {/* <CommunicationMethods p={p} /> */}
      </div>
    </div>
  );
};

export default PracticeDetails;
